import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get, APIError } from '../services/crud'
import { IServiceProduct } from './typings'
import { ISearchResponse } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.service}`

export const getServiceProductList = createAsyncThunk<
  IServiceProduct[],
  string,
  { rejectValue: APIError }
>('services/branch', async (branchId, thunkApi) => {
  const response = await get(`${baseUrl}/${branchId}`)

  if (response.ok) {
    const payload: ISearchResponse<IServiceProduct> = await response.json()
    return payload.items
  }
  return thunkApi.rejectWithValue(await response.json())
})

export const getServiceProductListForTenant = createAsyncThunk<
  IServiceProduct[],
  void,
  { rejectValue: APIError }
>('servicesForTenant', async (_, thunkApi) => {
  const response = await get(`${baseUrl}`)

  if (response.ok) {
    const payload: IServiceProduct[] = await response.json()
    return payload
  }
  return thunkApi.rejectWithValue(await response.json())
})
